import { Box, Button } from '@mui/material';
import { IBudget } from 'common/entities';

export interface AccumulationActionsProps {
  accumulation: IBudget;
  onCloseAccumulation: () => void;
}

const AccumulationActions = ({
  accumulation,
  onCloseAccumulation
}: AccumulationActionsProps) => {
  return (
    <Box>
      {!accumulation.closed && (
        <Button fullWidth onClick={onCloseAccumulation} variant="outlined">
          Close Accumulation
        </Button>
      )}
    </Box>
  );
};

export default AccumulationActions;
